import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

import { EyebrowTitle } from '@common/components/Typography';

export const ItemName = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin: 0;
  flex-grow: 1;

  a {
    color: inherit;
  }
`;

export const ItemNameText = styled.span`
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  display: inline-block;
  margin: 0;

  ${media.xl`
    font-size: 18px;
  `}
`;

export const RemoveButton = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.customColors.secondary};
  font-size: 15px;
  line-height: 1.2em;
  white-space: nowrap;
  margin-left: 10px;

  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }

  ${media.xl`
    font-size: inherit;
  `}
`;

export const ItemCategory = styled.section`
  margin-bottom: 20px;
  padding: 20px 0 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};

  ${media.xl`
    border: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
    padding: 20px 30px 10px 30px;
  `}
`;

export const PackageItemsWrapper = styled.section`
  margin-bottom: 20px;
  padding: 0 0 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};

  ${media.xl`
    border: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
    padding: 20px 30px 10px 30px;
  `}
`;

export const PackageItemCategory = styled.section`
  /* margin-bottom: 10px; */
  /* padding: 0px 0 10px 0; */
  border: none;

  ${media.xl`
    border-bottom: 1px solid ${({ theme, isLastItem }) =>
      isLastItem ? 'none' : theme.defaultColors.lightGrey};
    padding: 20px 0 10px 0;
  `}
`;

export const ItemRow = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  margin-left: 5px;
  margin-bottom: 20px;

  ${media.xl`
    margin-left: 10px;
  `}

  ${({ isWrap }) =>
    isWrap &&
    `
    flex-wrap: wrap;
  `}
`;

export const ItemPrice = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  flex-grow: 0;
  justify-content: flex-end;

  ${media.xl`
    margin-bottom: 0;
    padding: 0 10px;
    width: 115px;
    flex-shrink: 0;
  `}
`;

export const DetailTitle = styled(EyebrowTitle)`
  display: ${({ showOnMobile }) => (showOnMobile ? 'block' : 'none')};

  ${media.xl`
    display: block;
  `}
`;

export const DetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;
`;

export const PackageTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`;
